import { Box, CircularProgress } from "@mui/material";

const GridSpinner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: 4,
        height: "10rem"
      }}
    >
      <CircularProgress size="4rem" />
    </Box>
  );
};

export default GridSpinner;
